// Every admin page that renders a hacker/mentor's GitHub handle needs this: the stored
// value is sometimes a full profile URL, sometimes a bare handle. Keeps the stored
// casing, unlike `githubHandle` in lib/utils.
export function githubUsername(url: string | null): string | null {
  if (!url) return null;
  return url.replace(/^https?:\/\/(www\.)?github\.com\//, '').replace(/\/$/, '');
}
